import React, { useState } from 'react';
import './App.css';

function SalaryCalculator() {
  const [monthlySalary, setMonthlySalary] = useState(24500);
  const [socialSecurityBase, setSocialSecurityBase] = useState(6000);
  const [housingFundBase, setHousingFundBase] = useState(2300);
  const [housingFundRate, setHousingFundRate] = useState(0.05);
  const [housingCompanyFundRate, setHousingCompanyFundRate] = useState(0.05);
  const [specialDeduction, setSpecialDeduction] = useState(42000);
  const [bonusMonths, setBonusMonths] = useState(1);
  const [isBonusTaxedSeparately, setIsBonusTaxedSeparately] = useState(true);

  const calculateTax = (income) => {
    if (income <= 36000) {
      return income * 0.03;
    } else if (income <= 144000) {
      return income * 0.1 - 2520;
    } else if (income <= 300000) {
      return income * 0.2 - 16920;
    } else if (income <= 420000) {
      return income * 0.25 - 31920;
    } else if (income <= 660000) {
      return income * 0.3 - 52920;
    } else if (income <= 960000) {
      return income * 0.35 - 85920;
    } else {
      return income * 0.45 - 181920;
    }
  };

  const calculateAnnualIncome = () => {
    const monthlyPreTaxIncome = monthlySalary - (socialSecurityBase * 0.1) - (housingFundBase * housingFundRate);
    const annualPreTaxIncome = monthlyPreTaxIncome * 12 + monthlySalary * bonusMonths;

    let tax;
    if (isBonusTaxedSeparately) {
      tax = calculateTax(monthlyPreTaxIncome * 12 - specialDeduction - 60000) + calculateTax(monthlySalary * bonusMonths);
    } else {
      tax = calculateTax(annualPreTaxIncome - specialDeduction - 60000);
    }

    const annualPostTaxIncome = annualPreTaxIncome - tax;
    const housingFundIncome = ((housingFundBase * housingCompanyFundRate) + (housingFundBase * housingFundRate)) * 12;
    const annualIncome = annualPostTaxIncome + housingFundIncome;

    return {
      annualPreTaxIncome,
      tax,
      housingFundIncome,
      annualIncome,
      annualPostTaxIncome,
    };
  };

  const results = calculateAnnualIncome();

  return (
    <div className="App">
      <h1>薪资计算器</h1>
      <div className="input-container">
        <div className="input-group">
          <label>月薪: </label>
          <input
            type="number"
            step="100"
            value={monthlySalary}
            onChange={(e) => setMonthlySalary(parseFloat(e.target.value))}
          />
        </div>
        <div className="input-group">
          <label>社保基数: </label>
          <input
            type="number"
            step="100"
            value={socialSecurityBase}
            onChange={(e) => setSocialSecurityBase(parseFloat(e.target.value))}
          />
        </div>
        <div className="input-group">
          <label>公积金基数: </label>
          <input
            type="number"
            step="100"
            value={housingFundBase}
            onChange={(e) => setHousingFundBase(parseFloat(e.target.value))}
          />
        </div>
        <div className="input-group">
          <label>个人公积金比率: </label>
          <input
            type="number"
            step="0.01"
            value={housingFundRate}
            onChange={(e) => setHousingFundRate(parseFloat(e.target.value))}
          />
        </div>
        <div className="input-group">
          <label>公司公积金比率: </label>
          <input
            type="number"
            step="0.01"
            value={housingCompanyFundRate}
            onChange={(e) => setHousingCompanyFundRate(parseFloat(e.target.value))}
          />
        </div>
        <div className="input-group">
          <label>专项扣除: </label>
          <input
            type="number"
            value={specialDeduction}
            onChange={(e) => setSpecialDeduction(parseFloat(e.target.value))}
          />
        </div>
        <div className="input-group">
          <label>奖金月数: </label>
          <input
            type="number"
            value={bonusMonths}
            onChange={(e) => setBonusMonths(parseFloat(e.target.value))}
          />
        </div>
        <div className="input-group">
          <label>奖金是否独立计税: </label>
          <input
            type="checkbox"
            checked={isBonusTaxedSeparately}
            onChange={(e) => setIsBonusTaxedSeparately(e.target.checked)}
          />
        </div>
      </div>
      <div className="results-container">
        <h2>计算结果</h2>
        <p><strong>年税前收入:</strong> {results.annualPreTaxIncome.toFixed(2)}</p>
        <p><strong>个税:</strong> {results.tax.toFixed(2)}</p>
        <p><strong>公积金账户:</strong> {results.housingFundIncome.toFixed(2)}</p>
        <p><strong>年收入(加公积金账户):</strong> {results.annualIncome.toFixed(2)}</p>
        <p><strong>月到手平均收入:</strong> {(results.annualIncome / 12).toFixed(2)}</p>
      </div>
    </div>
  );
}

export default SalaryCalculator;

